export default __webpack_public_path__ + "static/media/Product2.3ddc4d69.PNG";